import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import Article from "../components/Article";

const ArticlePage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 文章列表">
            <NavOne />
            <PageHeader title="文章列表" />
            <Article />
            <Footer />
        </Layout>
    );
};

export default ArticlePage;
